import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  UncontrolledTooltip,
  // Badge,
  Input,
  Spinner,
  Table,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty} from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import SimpleReactValidator from "simple-react-validator"
import { ToastContainer, toast } from "react-toastify"
//import cellEditFactory from 'react-bootstrap-table2-editor'
//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as copyDataAction from "../../store/Y29weURhdGE/actions"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"


//CopyDataDetails
const CopyDataDetails = (props) => {
  // const { SearchBar } = Search
  const title = "Copy Data"
  const { dispatch, searchBtnStyle } = props

  useEffect(() => {
    dispatch(copyDataAction.loadRecordsMetaData())
    dispatch(copyDataAction.loadServiceLevel({ status: "both" }))
    dispatch(
      copyDataAction.loadDataCopy({
        page: 1,
        limit: 50,
      })
    )
  }, [])
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const simpleUploadValidator = useRef(new SimpleReactValidator())
  const [, forceUpload] = useState()
  //Reducer store state maintenance
  const specificDispatch = useDispatch()

  const eventCompleteUpdate = useSelector((state) => state.copyData)

  const { recordsMetaData = {}, data_copy_details = [], serviceLevel_details = [], nas_link_details = [], expandData = [] } = eventCompleteUpdate

  console.log(eventCompleteUpdate, "details")
  //nas link
  const serviceLevelStatusOptions = serviceLevel_details && !isEmpty(serviceLevel_details) ?
    serviceLevel_details.map((data) => {
      return {
        label: data.serviceLevelName,
        value: data._id
      }
    }) : []
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  //serviceOptions
  const serviceOptions = !isEmpty(recordsMetaData) && !isEmpty(recordsMetaData.serviceOptions) ?
    recordsMetaData.serviceOptions.filter(m => m.isDataApplicable == true).reduce((acc, m) => {
      if (!acc.some(option => option.label === m.label)) {
        acc.push({ label: m.label, value: m.value })
      }
      return acc
    }, []) : []

  //manage Ec initial state
  const [copyData, setCopyData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
    brideName: "",
    groomName: ""
  })
  const [crmName, setCrmName] = useState([])
  //handle change
  const handleChange = async (e) => {
    setCopyData({ ...copyData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [service, setService] = useState([])
  const [copyStatus, setCopyStatus] = useState([])
  // 

  const [resetManager, setResetManager] = useState(false)

  //reset functionalities
  const resetForm = () => {
    //   setIsFilter(false)
    setCompanies([])
    setBranches([])
    setEvents([])
    setCopyStatus([])
    setCrmName([])
    setService([])
    setSearchInput("")
    setCopyData({
      fromDate: "",
      toDate: "",
      leadNo: "",
      brideName: "",
      groomName: ""
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    })
    dispatch(
      copyDataAction.loadDataCopy({
        page: 1,
        limit: 50,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options



  const branchOptions =
    !isEmpty(recordsMetaData?.branchOptions) &&
      !isEmpty(companies?.value)
      ? recordsMetaData.branchOptions.filter(
        (branch) => branch.companyId === companies.value
      )
      : []


  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,

        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          searchFilter: searchInput,
        }

  //apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchCompany = !isEmpty(companies) && companies ? companies.value : ""
    var searchBranch = !isEmpty(branches) && branches ? branches.value : ""
    var searchEvent = events && events ? events.value : ""
    // var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchFromDate =
      copyData && copyData.fromDate
        ? moment(copyData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      copyData && copyData.toDate
        ? moment(copyData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = copyData && copyData.leadNo ? copyData.leadNo : ""
    var searchGroom = copyData && copyData.groomName ? copyData.groomName : ""
    var searchBride = copyData && copyData.brideName ? copyData.brideName : ""
    var searchService = !isEmpty(service) ? service.label : ""
    var searchCopy = !isEmpty(copyStatus) && copyStatus ? copyStatus.value : ""
    var searchCrmName = !isEmpty(crmName) ? crmName.value : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchCrmName) {
      searchvalue.crmId = searchCrmName
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }


    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchService) {
      searchvalue.serviceName = searchService
    }
    if (searchCopy) {
      searchvalue.serviceLevelStatusId = searchCopy
    }
    //
    setSearchValueList(searchvalue)
    setBtnLoading(true)
    specificDispatch(copyDataAction.loadDataCopy(searchvalue))
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }

  const [uploadQcData, setUploadQcData] = useState({
    description: ""
  })
  const handleQC = async (e) => {
    setUploadQcData({ ...uploadQcData, [e.target.name]: e.target.value })
  }
  const [updateLinkModal, setUpdateLinkModal] = useState(false)
  const [leadId, setLeadId] = useState("")
  //data table
  const [renderPage, setRenderPage] = useState(false)
  const [moveToCopiedModal, setMoveToCopiedModal] = useState(false)
  const handleCopiedModal = () => setMoveToCopiedModal(false)

  let slNo = 0
  const copyDataTable =
    !isEmpty(data_copy_details) && data_copy_details.data.length > 0
      ? data_copy_details.data.map((data, index) => {
        slNo = slNo + 1

        const colorCode =
          !isEmpty(recordsMetaData) &&
            recordsMetaData.processStatusOptions &&
            recordsMetaData.processStatusOptions.length > 0 ?
            recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === data.EC_Commit_Status

            ) &&
            recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === data.EC_Commit_Status

            ) : ""
        const nasColorCode = !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0 ?
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.nasProcessStatus

          ) &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.nasProcessStatus

          ) : ""
        const qcRemarkValue =
          !isEmpty(data.qcUploadLinkDetails) &&
            data.qcUploadLinkDetails.length > 0 &&
            data.qcUploadLinkDetails[data.qcUploadLinkDetails.length - 1] &&
            data.qcUploadLinkDetails[data.qcUploadLinkDetails.length - 1].qcRemarks !== undefined &&
            data.qcUploadLinkDetails[data.qcUploadLinkDetails.length - 1].qcRemarks !== null
            ? data.qcUploadLinkDetails[data.qcUploadLinkDetails.length - 1].qcRemarks
            : ""
        // const eventNameValue = !isEmpty(data.eventName) && data.eventName.length > 0 ?
        //   data.eventName.map((m) => m).join(",") : ""
        // const eventDateValue = !isEmpty(data.eventDate) && data.eventDate.length > 0 ?
        //   data.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : ""
        const eventDateValue = !isEmpty(data.eventDate)
          ? data.eventDate
            .map((m) => moment(m).format(dateFormat))
            .reduce((result, date, index) => {

              const groupIndex = Math.floor(index / 3)
              result[groupIndex] = result[groupIndex] || []
              result[groupIndex].push(date)
              return result
            }, [])
            .map((group) => group.join(", "))

            .join("\n")
          : "--"
        const eventNameValue = !isEmpty(data.eventName)
          ? data.eventName
            .map((m) => m)
            .reduce((result, date, index) => {

              const groupIndex = Math.floor(index / 3)
              result[groupIndex] = result[groupIndex] || []
              result[groupIndex].push(date)
              return result
            }, [])
            .map((group) => group.join(", "))
            .join("\n")
          : "--"
        return {
          _id: data._id,
          sNo: slNo,
          index: index,
          leadNo: data.leadNo,
          leadId: data.leadId,
          branchName: data.branchName,
          routeData: data,
          clientCode: data.clientCode ? data.clientCode : "--",
          clientId: data.clientId,
          companyName: data.companyName,
          leadServiceName: data.leadServiceName,
          leadSourceName: data.leadSourceName,
          leadType: data.leadType,
          salesUrge: data.salesUrge,
          colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",
          key: index,
          mobileNo: data.clientContact ? data.clientContact : "--",
          cpProfile: data.cpStatus ? data.cpStatus : "--",
          cpRemarks: data.cpRemarks ? data.cpRemarks : "--",
          brideName: data.brideName ? data.brideName : "--",
          groomName: data.groomName ? data.groomName : "--",
          services: data.noOfservice ? data.noOfservice : 0,
          pendingStatus: data.pendingStatus
            ? data.pendingStatus
            : "--",
          overAllStatus: data.dataOverAllStatus ? data.dataOverAllStatus : "",
          dataStatus: data.dataProcessStatusName
            ? data.dataProcessStatusName
            : "DATA COPY PENDING",
          uploadLinkDetails: data.serviceDetails,
          uploadStatus: data.uploadStatus ? data.uploadStatus : "--",
          uploadQc: data.uploadQc ? data.uploadQc : "--",
          qcUploadLinkProcessStatus: data.qcUploadLinkProcessStatus ? data.qcUploadLinkProcessStatus : "",
          qcUploadLinkProcessStatusName: data.qcUploadLinkProcessStatusName ? data.qcUploadLinkProcessStatusName : "",
          qcRemark: qcRemarkValue,
          eventDate: eventDateValue,
          eventName: eventNameValue,
          nasColorCode: !isEmpty(nasColorCode) ? nasColorCode.colorCode : "",
          nasProcessStatusName: data.nasProcessStatusName ? data.nasProcessStatusName
            : "PENDING",
          serviceArray: !isEmpty(data.serviceRecord) ? data.serviceRecord : [],
          EC_Status: data.EC_Status ? data.EC_Status : "",
          status: data.leadStatus,
          crmName: data.crmName ? data.crmName : "--",
          nasLinkCount: data.nasLinkCount || 0,
          ecCommitStatus: !isEmpty(data.eventDetails) && Array.isArray(data.eventDetails) &&
            data.eventDetails.every(event => 'isCommit' in event) ?
            data.eventDetails.every(event => event.isCommit) ? "Committed" : "Not committed"
            : "",
          ecName: data.EC_AssignedName || "--",
          eventDetails: data.eventDetails,
          isEligibleToCopy: data.isEligibleToCopy
        }
      })
      : []



  // const { ExportCSVButton } = CSVExport
  const updateLinkList = (row) => {
    const record = {
      leadId: row.leadId
    }
    dispatch(copyDataAction.loadNasLinkList(record))

  }
  const [addUpdateLinkData, setAddUpdateLinkData] = useState()
  const [pendingModal, setPendingModal] = useState(false)
  //pending status

  const [pendingData, setPendingData] = useState("")
  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      // formatter: (cellContent, row) => {
      //   const leadData = row.routeData
      //   return (
      //     <Link
      //       to={{
      //         pathname: `/client-details/${row.leadId}`,
      //         state: {
      //           row: leadData,
      //           mode: "Data",
      //           leadClientId: leadData,

      //         },
      //       }}
      //     >
      //       <span>{row.leadNo}</span>
      //     </Link>
      //   )
      // },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      hidden: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "nasLinkCount",
      text: "Nas Link",
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      formatter: (cellContent, row) => {

        return (
          <div>
            <Button
              className="btn btn-info"
              onClick={() => {
                handleHideMessages()
                setUpdateLinkModal(true)
                updateLinkList(row)
                setAddUpdateLinkData(row)
                clearUpdateLinkModal()
                setIsEdit(false)
              }}
              style={{ textWrap: "nowrap" }}
            >
              Add Nas Link ({cellContent})
            </Button>
          </div>
        )
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "moveToCopied",
      text: "Move To Copied",
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      formatter: (cellContent, row) => {

        return (
          <div>
            <Button
              className="btn btn-success"
              onClick={() => {
                setLeadId(row.leadId)
                setMoveToCopiedModal(true)

              }}
              disabled={row.isEligibleToCopy === false}
            >
              Move To Copied
            </Button>
          </div>
        )
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "status",
      text: "Lead Status",
      hidden: false,
      formatter: (cellContent, row) => {
        const bgColor = row.status == "COMPLETED" ? "#009933" : "#f46a6a"
        return (
          <div>
            {!isEmpty(row.status) ? (
              <button
                style={{
                  background: bgColor,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {!isEmpty(row.status) && row.status}
              </button>
            ) : (
              "--"
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },
    },
    {
      dataField: "EC_Status",
      text: "EC Status",
      hidden: false,
      formatter: (cellContent, row) => {
        const bgColor = row.EC_Status == "COMPLETED" ? "#009933" : "#f46a6a"
        //"#d63afd"
        return (
          <div>
            {!isEmpty(row.EC_Status) ? (
              <button
                style={{
                  background: bgColor,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {!isEmpty(row.EC_Status) && row.EC_Status}
              </button>
            ) : (
              "--"
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },

    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      hidden: false,
      style: {
        color: "#e40d8c",
      },
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            {!isEmpty(row.overAllStatus) ? (
              <span>{row.overAllStatus}</span>
            ) : (
              <span style={{ color: "#E40D8C" }}>PENDING</span>
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "pendingStatus",
      text: "Data Issues",
      hidden: false,
      style: {
        color: "#e40d8c",
      },
      formatter: (cellContent, row) => {
        const count = !isEmpty(row.pendingStatus) && row.pendingStatus.length > 0 ? row.pendingStatus.length : 0
        return (
          <div className="d-flex flex-row align-items-center">
            <i
              onClick={() => {
                setPendingModal(true)
                setPendingData(row.pendingStatus)
              }}
              className="fas fa-eye"
              style={{ color: "#50a5f1", fontSize: "16px", }}
            ></i>
            <div style={{ marginLeft: "40px" }}>
              <span className="badge rounded-pill bg-primary">
                {count}
              </span>
            </div>
          </div>
        )
      },

      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "ecName",
      text: "EC Name",
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "crmName",
      text: "Crm Name",
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "ecCommitStatus",
      text: "EC Commit Status",
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
      formatter: (cellContent, row) => {
        return (
          <div>
            {!isEmpty(row.ecCommitStatus) ? (
              <button
                style={{
                  background: row.ecCommitStatus == "Committed" ? "#009933" : "#f46a6a",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {!isEmpty(row.ecCommitStatus) && row.ecCommitStatus}
              </button>
            ) : (
              "--"
            )}
          </div>
        )
      },
    },



  ]

  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }


  const handleHideMessages = () => {
    simpleValidator.current.hideMessages()
    simpleUploadValidator.current.hideMessages()
    setRenderPage(!renderPage)
  }

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      copyDataAction.loadDataCopy({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = !isEmpty(companies) && companies ? companies.value : ""
    var searchBranch = branches && !isEmpty(branches) ? branches.value : ""
    var searchEvent = events && events ? events.value : ""
    var searchService = !isEmpty(service) ? service.label : ""
    var searchCopy = !isEmpty(copyStatus) ? copyStatus.value : ""
    var searchFromDate =
      copyData && copyData.fromDate
        ? moment(copyData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      copyData && copyData.toDate
        ? moment(copyData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = copyData && copyData.leadNo ? copyData.leadNo : ""
    var searchGroom = copyData && copyData.groomName ? copyData.groomName : ""
    var searchBride = copyData && copyData.brideName ? copyData.brideName : ""
    var searchCrmName = !isEmpty(crmName) ? crmName.value : ""
    var searchvalue = {}

    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchCrmName) {
      searchvalue.crmId = searchCrmName
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchService) {
      searchvalue.serviceName = searchService
    }
    if (searchCopy) {
      searchvalue.serviceLevelStatusId = searchCopy
    }

    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get_data_copy_scheduling_excel_export_new`, searchvalue)
      .then((response) => {
        const copyExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const eventName = !isEmpty(data.eventName) && data.eventName.length > 0 ?
              data.eventName.map((m) => m).join(",") : ""
            const eventDate = !isEmpty(data.eventDate) && data.eventDate.length > 0 ?
              data.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : ""
            const eventNameValue = !isEmpty(eventName)
              ? JSON.stringify(eventName).replace(/","/g, "\n")
              : "--"
            const eventDateValue = !isEmpty(eventDate)
              ? JSON.stringify(eventDate).replace(/","/g, "\n")
              : "--"
            return {
              _id: data._id,
              sNo: index + 1,
              index: index,
              leadNo: data.leadNo,
              leadId: data.leadId,
              branchName: data.branchName,
              routeData: data,
              clientName: data.clientName ? data.clientName : "--",
              clientId: data.clientId,
              clientCode: data.clientCode || "--",
              companyName: data.companyName,
              leadServiceName: data.leadServiceName,
              leadSourceName: data.leadSourceName,
              leadType: data.leadType,
              salesUrge: data.salesUrge,
              key: index,
              mobileNo: data.clientContact ? data.clientContact : "--",
              cpProfile: data.cpStatus ? data.cpStatus : "--",
              cpRemarks: data.cpRemarks ? data.cpRemarks : "--",
              brideName: data.brideName ? data.brideName : "--",
              groomName: data.groomName ? data.groomName : "--",
              services: data.noOfservice ? data.noOfservice : 0,
              //pendingStatus
              pendingStatus: data.pendingStatus
                ? data.pendingStatus
                : "--",
              overAllStatus: data.dataOverAllStatus ? data.dataOverAllStatus : "Pending",

              uploadLinkDetails: data.uploadLinkDetails,
              uploadStatus: data.uploadStatus ? data.uploadStatus : "--",
              eventDate: eventDateValue,
              eventName: eventNameValue,
              status: data.leadStatus,
              EC_Status: data.EC_Status ? data.EC_Status : "",
              nasProcessStatusName: data.nasProcessStatusName ? data.nasProcessStatusName : "Pending",
              crmName: data.crmName ? data.crmName : "--",
              nasLinkCount: data.nasLinkCount || 0,
              ecCommitStatus: !isEmpty(data.eventDetails) && Array.isArray(data.eventDetails) &&
                data.eventDetails.every(event => 'isCommit' in event) ?
                data.eventDetails.every(event => event.isCommit) ? "Committed" : "Not committed"
                : "--",
              ecName: data.EC_AssignedName || "--",
              dataStatus: !isEmpty(data.eventDetails) ? data.eventDetails.length : 0
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,Client Code,Bride Name,Groom Name,Event Name,Event Date,Nas Link,Lead Status, EC Status, Overall Status,Data Issues,EC Name,CRM Name,EC Commit Status",
          ]

          let usersCsv =
            !isEmpty(copyExportDataTable) &&
            copyExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientCode,
                brideName,
                groomName,
                eventName,
                eventDate,
                nasLinkCount,
                status,
                EC_Status,
                overAllStatus,
                dataStatus,
                ecName,
                crmName,
                ecCommitStatus
              } = user
              acc.push([
                sNo,
                leadNo,
                clientCode,
                brideName,
                groomName,
                eventName,
                eventDate,
                nasLinkCount,
                status,
                EC_Status,
                overAllStatus,
                dataStatus,
                ecName,
                crmName,
                ecCommitStatus
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "CopyDataDetails.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="index"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {" "}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="index"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          expandRow={expandRow}
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: data_copy_details.length,
    data:
      !isEmpty(data_copy_details) && data_copy_details.length > 0
        ? data_copy_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(data_copy_details) && data_copy_details.length > 0
        ? data_copy_details
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(events) ||
      !isEmpty(copyData.fromDate) ||
      !isEmpty(copyData.toDate) ||
      !isEmpty(copyStatus) ||
      !isEmpty(service) ||
      !isEmpty(copyData.leadNo) ||
      !isEmpty(crmName)

    ) {
      var searchCompany = !isEmpty(companies) && companies ? companies.value : ""
      var searchBranch = branches && !isEmpty(branches) ? branches.value : ""
      var searchEvent = events && events ? events.value : ""
      var searchService = !isEmpty(service) ? service.label : ""
      var searchCopy = !isEmpty(copyStatus) ? copyStatus.value : ""
      var searchCrmName = !isEmpty(crmName) ? crmName.value : ""

      var searchFromDate =
        copyData && copyData.fromDate
          ? moment(copyData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        copyData && copyData.toDate
          ? moment(copyData.toDate).format("YYYY-MM-DD")
          : ""
      var searchLeadNo = copyData && copyData.leadNo ? copyData.leadNo : ""

      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchService) {
        searchvalue.serviceName = searchService
      }
      if (searchCopy) {
        searchvalue.serviceLevelStatusId = searchCopy
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEvent) {
        searchvalue.eventNameId = searchEvent
      }
      if (searchFromDate) {
        searchvalue.eventStartDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventEndDate = searchToDate
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchCrmName) {
        searchvalue.crmId = searchCrmName
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(copyDataAction.loadDataCopy(searchvalue))
    } else {
      dispatch(
        copyDataAction.loadDataCopy({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }

    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //expand row functionality from bootstrap table
  const [updateModal, setUpdateModal] = useState(false)


  const [expanded, setExpanded] = useState([])
  const [serviceDetailsModal, setServiceDetailsModal] = useState(false)
  //service details initial array

  const [serviceDetailsData, setServiceDetailsData] = useState([
    {
      clientId: "",
      teamScheduleId: "",
      leadEventId: "",
      eventNo: "",
      eventId: "",
      eventName: "",
      eventDate: "",
      serviceNo: "",
      serviceId: "",
      serviceCode: "",
      serviceName: "",
      teamScheduleServiceId: "",
      teamType: "",
      teamScheduleConnectingId: "",
      teamEmployeeShooterId: "",
      teamEmployeeShooterName: "",
      mainFreelanceId: "",
      mainFreelanceName: "",
      subFreelancerId: "",
      subFreelanceName: "",
      dataCopyId: "",
      dataCopyConnectingId: "",
      serviceLevelStatusId: "",
      serviceLevelStatusName: "",
      fileCount: "",
      remarks: "",
      size: "",
      copiedDate: "",
    },
  ])

  //modal service details on change

  const modalChange = async (e, index, name) => {
    var serviceList = serviceDetailsData

    if (name == "serviceLevelStatusId") {
      serviceList[index]["serviceLevelStatusId"] = e.value
      serviceList[index]["serviceLevelStatusName"] = e.label
      setServiceDetailsData(serviceList)
    }
    if (name === "fileCount" || name === "size" || name === "remarks") {
      serviceList[index][name] = e.target.value
    }

    setRenderPage(!renderPage)
  }
  //clear popup

  // const clearServiceData = () => {
  //   setServiceDetailsData(prevState =>
  //     prevState.map(service => ({
  //       ...service,
  //       serviceLevelStatusName: "",
  //       serviceLevelStatusId: "",
  //       fileCount: "",
  //       size: "",
  //       remarks: ""
  //     }))
  //   )
  // }
  //





  // useEffect(() => {

  //   console.log(expandData)
  // }, [serviceDetailsModal])


  const updateData = async (payload) => {

    setServiceDetailsModal(true)

    await dispatch(
      copyDataAction.loadExpandData(payload))


  }
  useEffect(() => {
    if (!isEmpty(expandData)) {
      const dataCopyDetailsEditUpdated = expandData.map((data) => ({
        clientId: data.clientId,
        teamScheduleId: data.teamScheduleId,
        leadEventId: data.leadEventId,
        eventNo: data.eventNo,
        leadId: data.leadId,
        eventId: data.eventId,
        eventName: data.eventName,
        eventDate: data.eventDate,
        serviceNo: data.serviceNo,
        serviceId: data.serviceId,
        serviceCode: data.serviceCode,
        serviceName: data.serviceName,
        teamScheduleServiceId: data.teamScheduleServiceId,
        teamType: data.teamType,
        teamScheduleConnectingId: data.teamScheduleConnectingId,
        teamEmployeeShooterId: data.teamEmployeeShooterId,
        teamEmployeeShooterName: data.teamEmployeeShooterName,
        mainFreelanceId: data.mainFreelanceId,
        mainFreelanceName: data.mainFreelanceName,
        subFreelancerId: data.subFreelancerId,
        subFreelanceName: data.subFreelanceName,
        dataCopyId: data.dataCopyId,
        dataCopyConnectingId: data.dataCopyConnectingId,
        serviceLevelStatusId: data.serviceLevelStatusId || "",
        serviceLevelStatusName: data.serviceLevelStatusName || "",
        fileCount: data.fileCount || "",
        remarks: data.remarks || "",
        size: data.size || "",
        copiedDate: data.copiedDate,
      }))
      setServiceDetailsData(dataCopyDetailsEditUpdated)
    }
  }, [expandData]) // Ensure this runs when expandData updates

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>

              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Data Details
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Shoot Lead Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Branch
              </th>

            </tr>
          </thead>
          <tbody>
            {row &&
              row.eventDetails
              &&
              row.eventDetails
                .length > 0 ? (
              row.eventDetails
                .map((data) => {
                  console.log(row, "rowd")
                  const leadId = row && row.leadId
                  const eventId = data.eventId
                  const payload = {
                    leadId: leadId,
                    eventId: eventId
                  }
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventName || "--"}</th>
                      <td>{data.eventDate && data.eventDate != null ? moment(data.eventDate).format(dateFormat) : "--"}</td>
                      <td>{<Button
                        style={{
                          border: "none",
                          cursor: "pointer",
                          padding: "4px 8px",
                          borderRadius: "3px",
                        }}
                        onClick={() => {
                          updateData(payload)

                        }}
                        className="btn btn-success"

                      >
                        <i
                          className="fas fa-edit icon-btn"
                          style={{ fontSize: "10px" }}
                        ></i>
                      </Button>}</td>
                      <td>{data.shootLeadName || "--"}</td>
                      <td>{data.venueName || "--"}</td>
                      <td>{data.venueLocationName || "--"}</td>
                      <td>{data.branchName || "--"}</td>
                    </tr>
                  )
                })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    expanded,
    onExpand: (row, isExpand) => {
      if (isExpand) {
        //setExpanded([...expanded, row._id])
        setExpanded([row.index])
      } else {
        // setExpanded(expanded.filter((id) => id !== row._id))
        setExpanded([])
      }
    },
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
   
  const updateDataExpand = async () => {
    const serviceData = serviceDetailsData && serviceDetailsData.filter(m => 
      m.fileCount !== undefined && m.fileCount !== "" ||
      m.remarks !== undefined && m.remarks !== "" ||
      m.size !== undefined && m.size !== "" ||
      m.serviceLevelStatusId !== undefined && m.serviceLevelStatusId !== ""
    )
    const payload = {
      services: serviceData
    }
    await dispatch(copyDataAction.updateExpand(payload))
    toast.success("Data Details Updated successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    })
    setServiceDetailsModal(false)
  }
  //setUpdateLinkData
  const folderTypeOptions = [{ label: "PHOTO", value: "PHOTO" }, { label: "CANDID VIDEO", value: "CANDID VIDEO" },
  { label: "TRADITIONAL VIDEO", value: "TRADITIONAL VIDEO" }]
  const [isEdit, setIsEdit] = useState(false)
  const [updateLinkData, setUpdateLinkData] = useState([
    {
      folderType: "",
      folderTypeValue: "",
      statusId: "",
      statusName: "",
      fileCount: "",
      size: "",
      link: "",
      _id: "",
      remarks: ""
    },
  ])
  const addUpdateLinkDetails = () => {
    setUpdateLinkData([
      ...updateLinkData,
      {
        folderType: "",
        folderTypeValue: "",
        statusId: "",
        statusName: "",
        fileCount: "",
        size: "",
        link: "",
        _id: "",
        remarks: ""
      },
    ])
    setRenderPage(!renderPage)
  }

  const nasChange = (e, index, name) => {
    const paymentdataList = [...updateLinkData]
    if (name === "fileCount" || name === "size" || name === "link" || name === "remarks") {
      paymentdataList[index][name] = e.target.value
    }
    if (name === "statusId") {
      paymentdataList[index]["statusId"] = e.value
      paymentdataList[index]["statusName"] = e.label
    }
    if (name === "folderTypeValue") {
      paymentdataList[index]["folderTypeValue"] = e.value
      paymentdataList[index]["folderType"] = e.label

    }
    setUpdateLinkData(paymentdataList)
    setRenderPage(!renderPage)
  }
  const removeNasdetails = async (toRemove) => {
    var paymentList = updateLinkData
    if (toRemove != 0) {
      if (toRemove > -1) {
        paymentList.splice(toRemove, 1)
      }
      setUpdateLinkData(paymentList)
      setRenderPage(!renderPage)
    }
  }

  const addUploadData =
    !isEmpty(updateLinkData) && updateLinkData.length > 0
      ? updateLinkData.map((data) => {
        if (data) {
          return {

            "folderType": data.folderTypeValue,
            "serviceLevelStatusId": data.statusId,
            "fileCount": data.fileCount,
            "size": data.size,
            "link": data.link,
            "remarks": data.remarks
          }
        }
      })
      : []

  const addUpdateLink = () => {
    const formValid = simpleValidator.current.allValid()
    if (formValid) {
      const addNasLinkData = {
        "leadId": addUpdateLinkData.leadId,
        "clientId": addUpdateLinkData.clientId,
        "nasLinkDetails": addUploadData
      }
      dispatch(copyDataAction.addNasLink(addNasLinkData))
      setTimeout(() => {
        dispatch(copyDataAction.loadNasLinkList({ leadId: addUpdateLinkData.leadId }))

        clearUpdateLinkModal()
        toast.success("Add Nas Link Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        handleHideMessages()
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      setRenderPage(!renderPage)
      forceUpdate(1)
    }
  }
  const editUploadLinkDetails = (item) => {
    setUpdateLinkData([{

      folderType: item.folderType,
      folderTypeValue: item.folderType,
      statusId: item.serviceLevelStatusId._id,
      statusName: item.serviceLevelStatusId.serviceLevelName,
      fileCount: item.fileCount,
      size: item.size,
      link: item.link,
      _id: item._id,
      leadId: item.leadId,
      clientId: item.clientId,
      remarks: item.remarks
    }])
  }

  const editUpdateLink = () => {
    const formValid = simpleValidator.current.allValid()
    if (formValid) {
      const updateLink = updateLinkData[0]
     
      const nasLinkDetailsData = {
        "_id": updateLink._id,
        "leadId": updateLink.leadId,
        "clientId": updateLink.clientId,
        "folderType": updateLink.folderTypeValue,
        "serviceLevelStatusId": updateLink.statusId,
        "fileCount": updateLink.fileCount,
        "size": updateLink.size,
        "link": updateLink.link,
        "remarks": updateLink.remarks
      }
      dispatch(copyDataAction.updateNasLink(nasLinkDetailsData))
      setTimeout(() => {
        dispatch(copyDataAction.loadNasLinkList({ leadId: updateLink.leadId }))
        toast.success("Nas Link Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        handleHideMessages()
        setIsEdit(false)
        clearUpdateLinkModal()
      }, 1000)

    } else {
      simpleValidator.current.showMessages()
      setRenderPage(!renderPage)
      forceUpdate(1)
    }
  }

  const clearUpdateLinkModal = () => {
    setUpdateLinkData([{
      folderType: "",
      folderTypeValue: "",
      statusId: "",
      statusName: "",
      fileCount: "",
      size: "",
      link: "",
      _id: "",
      leadId: "",
      clientId: "",
      remarks: ""
    },
    ])
  }
  const [deleteUpdateLinkmodal, setDeleteUpdateLinkmodal] = useState(false)
  const [deleteDetails, setDeleteDetails] = useState("")
  const deleteUploadLink = () => {
    const deleteNasLinkData = {
      "naslinkId": deleteDetails._id,
      "leadId": deleteDetails.leadId,
      "status": 3
    }
    dispatch(copyDataAction.removeNasLink(deleteNasLinkData))
    setTimeout(() => {
      dispatch(copyDataAction.loadNasLinkList({ leadId: deleteDetails.leadId }))
      toast.success("Nas Link Deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)

  }

  const uploadApproval = () => {
    const formValid = simpleUploadValidator.current.allValid()
    if (formValid) {
      const qcDetails = {
        leadId: leadId,
        processStatus: "PS76",
        processStatusName: "UPLOAD LINK QC APPROVED",
        remarks: uploadQcData.description

      }
      dispatch(copyDataAction.uploadQc(qcDetails))
      setTimeout(() => {
        dispatch(
          copyDataAction.loadDataCopy(searchValue)
        )
        toast.success("Approved successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        handleHideMessages()
        setUpdateModal(false)
      }, 1000)
    } else {
      simpleUploadValidator.current.showMessages()
      setRenderPage(!renderPage)
      forceUpload(1)
    }
  }

  const uploadRecheck = () => {
    const formValid = simpleUploadValidator.current.allValid()
    if (formValid) {
      const qcDetails = {
        leadId: leadId,
        processStatus: "PS77",
        processStatusName: "UPLOAD LINK QC RECHECK",
        remarks: uploadQcData.description

      }
      dispatch(copyDataAction.uploadQc(qcDetails))
      setTimeout(() => {
        dispatch(
          copyDataAction.loadDataCopy(searchValue)
        )
        toast.success("Approved successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        handleHideMessages()
        setUpdateModal(false)
      }, 1000)
    } else {
      simpleUploadValidator.current.showMessages()
      setRenderPage(!renderPage)
      forceUpload(1)
    }
  }
  const addCopied = () => {
    const copyDetails = {
      leadId: leadId,

    }
    dispatch(copyDataAction.updateCopy(copyDetails))
    setTimeout(() => {
      dispatch(
        copyDataAction.loadDataCopy(searchValue)
      )
      setMoveToCopiedModal(false)
      toast.success("Data Copy Updated Successfully")
    }, 1000)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={copyData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                          isClearable
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                          isClearable
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                          isClearable
                        />
                      </Col>


                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={copyData.fromDate}
                          max={copyData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={copyData.toDate}
                          min={copyData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Bride Name"}
                          >
                            {"Bride Name"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Bride Name"
                          name="brideName"
                          value={copyData.brideName}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Groom Name"}
                          >
                            {"Groom Name"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Groom Name"
                          name="groomName"
                          value={copyData.groomName}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col> */}
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Service"}</Label>
                        </div>
                        <Select

                          type="text"
                          name="service"
                          value={service}
                          // isMulti
                          onChange={(e) => setService(e)}
                          options={serviceOptions}
                          placeholder="Select Service"
                          classNamePrefix="select2-selection"
                          isClearable
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Copy Status"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="copyStatus"
                          value={copyStatus}
                          // isMulti
                          onChange={(e) => setCopyStatus(e)}
                          options={
                            recordsMetaData ? recordsMetaData.copyStatusOptions : []
                          }
                          placeholder="Select Copy Status"
                          classNamePrefix="select2-selection"
                          isClearable
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"CRM Name"}</Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="crmName"
                          key={resetManager}
                          items={
                            !isEmpty(recordsMetaData)
                              ? recordsMetaData.employeeOptions
                              : []
                          }
                          value={crmName}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setCrmName(e)}
                          onClear={() => setCrmName([])}
                          onChange={(e) => setCrmName(e.target.value)}
                          placeholder="Enter CRM Name"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={copyDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(data_copy_details)
                        ? data_copy_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {updateModal && (
          <Modal show={updateModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Upload QC</span>
              </div>

            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col sm="12" md="12" xl="12" lg="12">
                  <div className="d-flex justify-content-between">
                    <Label
                      className="form-label"
                      htmlFor={"Event To Date"}
                    >
                      {"Description"}<span className="required ms-1">*</span>
                    </Label>
                  </div>
                  <Input
                    type="textarea"
                    placeholder="Enter Description"
                    name="description"
                    value={uploadQcData.description}
                    onChange={(e) => handleQC(e)}
                  />
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleUploadValidator.current.message(
                      "Description",
                      uploadQcData.description,
                      "required"
                    )}
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  // type="submit"
                  onClick={() => {
                    setUpdateModal(false)
                  }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  Cancel
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={() => {

                    uploadApproval()
                  }}
                  className="btn btn-success buttons"
                >
                  {" "}
                  Approval
                </Button>
                <Button
                  type="submit"
                  onClick={() => {

                    uploadRecheck()
                  }}
                  style={{ marginLeft: "10px" }}
                  className="btn btn-warning buttons"
                >
                  {" "}
                  Recheck
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {updateLinkModal && (
          <Modal show={updateLinkModal} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              Nas Link
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setUpdateLinkModal(false)}
                  style={{ color: "white" }}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg="12" md="12" sm="12">
                  {isEdit == false ? <Button
                    style={{
                      backgroundColor: "#4486eb",
                      border: "none",
                      marginTop: "20px",
                      float: "right",
                    }}
                    onClick={() => {
                      addUpdateLinkDetails()
                    }}
                  >
                    Add
                  </Button> : ""}
                </Col>
                <Col sm="12" md="12" lg="12" className="mt-2">
                  <Table striped bordered>
                    <thead>
                      <tr style={{ fontSize: "10px" }}>
                        <th style={{ width: "15%" }}>Folder Type</th>
                        <th style={{ width: "15%" }}>Status</th>
                        <th style={{ width: "15%" }}>File Count</th>
                        <th style={{ width: "15%" }}>Size</th>
                        <th style={{ width: "20%" }}>Link</th>
                        <th style={{ width: "15%" }}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {updateLinkData &&
                        updateLinkData.length > 0 &&
                        updateLinkData.map((data, index) => {
                          return (
                            <>
                              <tr className="bg-white" key={index}>
                                <td style={{ width: "15%" }}>
                                  {" "}
                                  <Select
                                    type="text"
                                    name="folderTypeValue"
                                    value={
                                      data.folderTypeValue
                                        ? {
                                          value: data.folderTypeValue,
                                          label: data.folderType,
                                        }
                                        : { value: "", label: "Select" }
                                    }
                                    onChange={(e) =>
                                      nasChange(e, index, "folderTypeValue")
                                    }
                                    placeholder="Enter"
                                    classNamePrefix="select2-selection"
                                    options={folderTypeOptions}
                                  />
                                  <div style={{ textTransform: "capitalize" }}>
                                    {simpleValidator.current.message(
                                      "FolderType",
                                      data.folderTypeValue,
                                      "required"
                                    )}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <Select
                                    type="text"
                                    name="statusId"
                                    value={
                                      data.statusId
                                        ? {
                                          value: data.statusId,
                                          label: data.statusName,
                                        }
                                        : { value: "", label: "Select" }
                                    }
                                    onChange={(e) =>
                                      nasChange(e, index, "statusId")
                                    }
                                    placeholder="Enter"
                                    classNamePrefix="select2-selection"
                                    options={serviceLevelStatusOptions}
                                  />
                                  <div style={{ textTransform: "capitalize" }}>
                                    {simpleValidator.current.message(
                                      "Status",
                                      data.statusId,
                                      "required"
                                    )}
                                  </div>
                                </td>

                                <td style={{ width: "15%" }}>
                                  {" "}
                                  <Input
                                    type="text"
                                    name="fileCount"
                                    value={data.fileCount}
                                    onChange={(e) =>
                                      nasChange(e, index, "fileCount")
                                    }
                                    placeholder="Enter File Count"
                                  />
                                </td>
                                <td style={{ width: "15%" }}>
                                  {" "}
                                  <Input
                                    type="text"
                                    name="size"
                                    value={data.size}
                                    onChange={(e) =>
                                      nasChange(e, index, "size")
                                    }
                                    placeholder="Enter Size"
                                  />
                                  <div style={{ textTransform: "capitalize" }}>
                                    {simpleValidator.current.message(
                                      "Size",
                                      data.size,
                                      "required"
                                    )}
                                  </div>
                                </td>
                                <td style={{ width: "20%" }}>
                                  {" "}
                                  <Input
                                    type="text"
                                    name="link"
                                    value={data.link}
                                    onChange={(e) =>
                                      nasChange(e, index, "link")
                                    }
                                    placeholder="Enter Link"
                                  />
                                  <div style={{ textTransform: "capitalize" }}>
                                    {simpleValidator.current.message(
                                      "Link",
                                      data.link,
                                      "required"
                                    )}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  {" "}
                                  <Input
                                    type="text"
                                    name="remarks"
                                    value={data.remarks}
                                    onChange={(e) =>
                                      nasChange(e, index, "remarks")
                                    }
                                    placeholder="Enter remarks"
                                  />

                                </td>
                                {isEdit == false ? <td>
                                  {" "}
                                  <i
                                    className="fa fa-times remove-icon"
                                    onClick={() => removeNasdetails(index)}
                                  ></i>{" "}
                                </td> : ""}
                              </tr>
                            </>
                          )
                        })}
                    </tbody>
                  </Table>
                </Col>
                <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                  <div
                    className="filter-buttons"
                    style={{ float: "right" }}
                  >
                    <Button
                      className="btn btn-danger"
                      onClick={() => setUpdateLinkModal(false)}
                      style={{ marginRight: "15px" }}
                    >
                      Cancel
                    </Button>
                    {isEdit ? <Button
                      className="btn btn-success"
                      onClick={() => editUpdateLink()}
                    >
                      Update
                    </Button> : <Button
                      className="btn btn-success"
                      onClick={() => addUpdateLink()}
                    >
                      Submit
                    </Button>}
                  </div></Col>
                <Col lg="9" md="9" sm="12" className="mt-3">
                  <p className="quote-head">
                    Nas Link
                    <span className="quote-info">
                      <i
                        style={{ color: "grey" }}
                        id="quoteInfo12"
                        aria-hidden="true"
                        className="fa fa-info-circle ms-1"
                      ></i>
                      <UncontrolledTooltip placement="right" target="quoteInfo12">
                        Nas Link
                      </UncontrolledTooltip>
                    </span>
                  </p>
                </Col>

                <Col md="12" lg="12" xl="12" className="mt-3">
                  <Table striped bordered>
                    <thead>
                      <tr style={{ fontSize: "10px" }}>
                        {/* <th>S.No</th> */}
                        <th style={{ width: "7%" }}>S.No</th>
                        <th style={{ width: "8%" }}>Actions</th>
                        <th style={{ width: "10%" }}>Folder Type</th>
                        <th style={{ width: "15%" }}>Status</th>
                        <th style={{ width: "10%" }}>File Count</th>
                        <th style={{ width: "10%" }}>Size</th>
                        <th style={{ width: "25%" }}>Link</th>
                        <th style={{ width: "15%" }}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {nas_link_details && !isEmpty(nas_link_details) && nas_link_details.length > 0 ?
                        nas_link_details.map((item, index) => {

                          return (<tr key={index}>
                            <td>{index + 1}</td>
                            <td>{<div style={{ display: "flex" }}>
                              <Button
                                type="submit"
                                onClick={() => {

                                  editUploadLinkDetails(item)
                                  setIsEdit(true)
                                }}
                                style={{ fontSize: "10px" }}
                                className="btn btn-success buttons btn-sm"
                              >
                                <i
                                  className="fas fa-pencil-alt icon-btn fa-sm"
                                  style={{ fontSize: "13px" }}
                                ></i>
                              </Button>
                              <Button
                                type="submit"
                                onClick={() => {
                                  setDeleteDetails(item)
                                  setDeleteUpdateLinkmodal(true)

                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-danger buttons btn-sm"
                              >
                                <i
                                  className="fas fa-trash-alt icon-btn fa-sm"
                                  style={{ fontSize: "12px" }}
                                ></i>
                              </Button>
                            </div>}</td>
                            <td>{item.folderType}</td>
                            <td>{item.serviceLevelStatusId != null ? item.serviceLevelStatusId.serviceLevelName : ""}</td>
                            <td>{item.fileCount ? item.fileCount : "--"}</td>
                            <td>{item.size ? item.size : "--"}</td>
                            <td>{item.link ? item.link : "--"}</td>
                            <td>{item.remarks ? item.remarks : "--"}</td>
                          </tr>
                          )
                        }) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={8}>
                              No data found
                            </td>
                          </tr>
                        )}

                    </tbody></Table>
                </Col>
              </Row>
            </Modal.Body>

          </Modal>
        )}
        {columnModal && (
          <Modal size="xl" show={columnModal}>
            <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Edit Columns
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setColumnModal(false)}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <div>
                  <Input
                    type="checkbox"
                    checked={selectedColumns.length === columns.length}
                    onChange={(e) => handleSelectAllChange(e)}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                    Select All
                  </Label>
                </div>
              </Row>
              <Row>
                <Col sm="12" md="6" lg="6" className="ml-4">
                  {oddColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
                <Col sm="12" md="6" lg="6">
                  {evenColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <p
                className="text-decoration-underline text-info"
                style={{ cursor: "pointer", fontSize: "16px" }}
                onClick={handleRestoreToDefault}
              >
                Restore To Default
              </p>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setColumnModal(false)
                  setSelectedColumns(selectColumn)
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => handleSaveColumns()}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {btnLoading ? (
          <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {loading ? (
          <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {deleteUpdateLinkmodal && (
          <Modal show={deleteUpdateLinkmodal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              {"Delete Nas Link"}
            </Modal.Header>
            <Modal.Body>Do you want To Delete the Update Link?</Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    deleteUploadLink()
                    setTimeout(() => {
                      setDeleteUpdateLinkmodal(false)
                    }, 500)
                  }}
                  style={{ fontSize: "10px", marginLeft: "20px" }}
                  className="btn btn-success buttons"
                >
                  {" "}
                  Yes
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    setDeleteUpdateLinkmodal(false)
                  }}
                  style={{ fontSize: "10px", marginLeft: "20px" }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  No
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {pendingModal && (
          <Modal size="xl" show={pendingModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Pending Status
            </Modal.Header>
            <Modal.Body>


              <Row className="mt-3">
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Event Name</th>
                      <th>Event Date</th>
                      <th>Service Name</th>
                      <th>Type</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>File Count</th>
                      <th>File Size</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {!isEmpty(pendingData) &&
                      pendingData.length > 0 ? (
                      pendingData.map((data, index) => {
                        const typeName = data.type != "InHouse" ? data.freelancerName : data.EmployeName

                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.eventName ? data.eventName : "--"}</td>
                            <td>{data.eventDate ? moment(data.eventDate).format(dateFormat) : "--"}</td>
                            <td>{data.serviceName ? data.serviceName : "--"}</td>
                            <td>{data.type ? data.type : "--"}</td>
                            <td>{typeName}</td>
                            <td>{data.status ? data.status : "--"}</td>
                            <td>
                              {data.fileCount ? data.fileCount : "--"}
                            </td>
                            <td>{data.size ? data.size : "--"}</td>
                            <td>{data.remarks ? data.remarks : "--"}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td className="text-align-center" colSpan={10}>
                          No Records Found...
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>

            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setPendingModal(false)}
              >
                Close
              </Button>

            </Modal.Footer>
          </Modal>
        )}
        {moveToCopiedModal && (
          <Modal show={moveToCopiedModal} onHide={handleCopiedModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Move To Copied</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              Are You Sure Do You Want To Move To Copied?
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setMoveToCopiedModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={() => addCopied()}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {serviceDetailsModal && (
          <Modal show={serviceDetailsModal} size="xl">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Data Details Update
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12">
                <Table responsive striped>
                  <thead>
                    <tr style={{ fontSize: "10px" }}>
                      {/* <th>S.No</th> */}
                      <th style={{ minWidth: "100px", maxWidth: "70px" }}>Service Number</th>
                      <th style={{ minWidth: "100px", maxWidth: "80px" }}>Service Name</th>
                      <th style={{ minWidth: "100px", maxWidth: "100px" }}>Team Shooter</th>
                      <th style={{ minWidth: "100px", maxWidth: "80px" }}>Freelancer Name</th>
                      <th style={{ minWidth: "100px", maxWidth: "100px" }}>Sub Freelancer Name</th>
                      <th style={{ minWidth: "160px", maxWidth: "160px" }}>Data Status</th>
                      <th style={{ minWidth: "40px", maxWidth: "40px" }}>File Count</th>
                      <th style={{ minWidth: "40px", maxWidth: "40px" }}>Size</th>
                      <th style={{ minWidth: "40px", maxWidth: "40px" }}>Remarks</th>
                      <th style={{ minWidth: "40px", maxWidth: "40px" }}>Copied Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(serviceDetailsData) ? (
                      serviceDetailsData.map((service, index) => {
                        //Sub freelancer dropdown
                        console.log(index, "index")

                        return (
                          <tr
                            key={index}

                          >
                            <td >
                              {service.serviceNo}
                            </td>
                            <td >
                              {service.serviceName}
                            </td>
                            <td>{service.teamEmployeeShooterName || "--"}</td>
                            <td>{service.mainFreelanceName || "--"}</td>
                            <td>{service.subFreelanceName || "--"}</td>

                            <td style={{ textAlign: "center" }}>
                              <Select
                                name="serviceLevelStatusId"
                                value={
                                  service.serviceLevelStatusId
                                    ? {
                                      value: service.serviceLevelStatusId,
                                      label: service.serviceLevelStatusName,
                                    }
                                    : { value: "", label: "Select" }
                                }
                                options={serviceLevelStatusOptions}

                                onChange={(e) =>
                                  modalChange(e, index, "serviceLevelStatusId")
                                }
                                placeholder="Select Status"
                                classNamePrefix="select2-selection"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                              />
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <Input
                                type="text"
                                name="fileCount"
                                value={service.fileCount}
                                onChange={(e) =>
                                  modalChange(e, index, "fileCount")
                                }
                                placeholder="File Count"
                              />

                            </td>
                            <td style={{ textAlign: "center" }}>
                              <Input
                                type="text"
                                name="size"
                                value={service.size}
                                onChange={(e) =>
                                  modalChange(e, index, "size")
                                }
                                placeholder="Enter Size"
                              />

                            </td>
                            <td style={{ textAlign: "center" }}>
                              <Input
                                type="text"
                                name="remarks"
                                value={service.remarks}
                                onChange={(e) =>
                                  modalChange(e, index, "remarks")
                                }
                                placeholder="Enter Remarks"
                              />
                            </td>
                            <td>{service.copiedDate != null ? moment(service.copiedDate).format(dateFormat) : "--"}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td
                          colSpan={10}
                          className="text-align-center"
                        >
                          No Records Found..
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setServiceDetailsModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={() => updateDataExpand()}
                //  onClick={() => setServiceDetailsModal(false)}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

CopyDataDetails.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  row: PropTypes.object
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})
//CopyDataDetails
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CopyDataDetails)
)
